import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=22df7761&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=22df7761&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df7761",
  null
  
)

export default component.exports